<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMicrophoneMutedByHost_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M8.1 5.8c-.418.374-.76.83-1.003 1.344L3.083 3.13A2.52 2.52 0 0 1 5.572 1 2.53 2.53 0 0 1 8.1 3.529zM.72 1.958l6.075 6.076a4.2 4.2 0 0 0 .022 1.897c-.366.215-.789.342-1.245.342a2.53 2.53 0 0 1-2.53-2.529V5.473L.124 2.553a.422.422 0 0 1 .596-.595M10.898 13.133h.053a.4.4 0 0 1-.14 0z"
    />
    <path
        fill="currentColor"
        d="M5.993 11.936a4.1 4.1 0 0 0 1.549-.478 4.2 4.2 0 0 1-.442-.729 3.2 3.2 0 0 1-1.528.387A3.375 3.375 0 0 1 2.2 7.744v-.843a.422.422 0 0 0-.843 0v.843c0 2.18 1.669 3.957 3.793 4.172v1.73a.422.422 0 0 0 .843 0z"
    />
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M10.733 5.667a3.267 3.267 0 1 0 0 6.533 3.267 3.267 0 0 0 0-6.533m0 4.9a.327.327 0 0 0 0-.654h-.003a.327.327 0 0 0 0 .654zm-.326-1.634a.327.327 0 1 0 .653 0V7.627a.327.327 0 0 0-.653 0z"
        clip-rule="evenodd"
    />
</svg>
